import React, { useEffect, useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import CreateMedicationFormTemplate from "../templates/CreateMedicationFormTemplate";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";

interface Ref {
  show: (initialMedication?: MedicationModel) => void;
}

const CreateEditMedicationModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [initialMedication, setInitialMedication] = useState<MedicationModel>();
  const [isEditing, setIsEditing] = useState(false);

  useImperativeHandle(ref, () => ({
    show: (initialMedication?: MedicationModel) => {
      setShowing(true);
      setInitialMedication(initialMedication);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  useEffect(() => {
    if (showing) {
      setIsEditing(!!initialMedication);
    }
  }, [showing, initialMedication]);

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Add new medication"
      hasCancelButton
      isEditing={isEditing}
    >
      <CreateMedicationFormTemplate
        initialMedication={initialMedication}
        onClose={handleClose}
        isEditing={isEditing}
      />
    </ReusableModal>
  );
});

CreateEditMedicationModal.displayName = "CreateMedicationModal";
export { CreateEditMedicationModal };
